import script from "./RankDetailsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RankDetailsPage.vue?vue&type=script&setup=true&lang=ts"

import "./RankDetailsPage.vue?vue&type=style&index=0&id=6d8128ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8128ce"]])

export default __exports__